<template>
	<page class="">
		<div>
			<v-expansion-panels multiple v-model="openPanels" focusable readonly v-if="type && type.can_live_edit == 0">
				<v-expansion-panel v-if="isNew">
					<v-expansion-panel-header>
						{{ this.$t("generics.gameSettings") }}
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<game-form @save="onSave" />
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
      <v-container fluid :disabled="isNew" v-if="!type || (type && !type.can_live_edit)">
        <game-question-view @share="shareDialogOpen=true" @openHelpDialog="showTypeHelp=true" @delete="onDelete"/>
      </v-container>
    </div>
		<div v-if="type && type.can_live_edit && game" class="mt-3 pb-5 mb-5">
			<GameDisplayView @share="shareDialogOpen=true" @openHelpDialog="showTypeHelp=true" @delete="onDelete"/>
		</div>
		<div v-else>
			<type-circle hide-image hide-name style="position: fixed;bottom: 175px;left: 62px" v-if="type"
				:type="type" />

		</div>
    <share-dialog v-model="shareDialogOpen" :game="game" />

    <type-help-dialog v-model="showTypeHelp" @close="showTypeHelp = false" v-if="game.type && game.type.help_link"
                      :src="game.type.help_link" />

  </page>
</template>

<script>
import GameForm from "./GameForm";
import GameQuestionView from "../gameQuestions/GameQuestionView";
import { types } from "../../store/modules/Game.module";
import GameDisplayView from "src/view/games/GameView";
import TypeCircle from "../types/TypeCircle";
import TypeHelpDialog from "src/view/types/TypeHelpDialog";
import ShareDialog from "src/view/share/ShareDialog.vue";
export default {
	name: "CreateGame",
	components: { TypeCircle, GameQuestionView, GameForm, GameDisplayView,TypeHelpDialog, ShareDialog},
	data() {
		return {
			openPanels: [0],
      showTypeHelp: false,
      shareDialogOpen: false,
		};
	},
	computed: {
		game() {
			return this.$store.getters.game;
		},
		type() {console.log(this.game.type, this.game.type ? this.game.type.can_live_edit : null);
			return this.game.type;
		},
		isNew() {
			return this.game.id === undefined;
		},
		routeGameId() {
			return this.$route.params.id;
		},
	},
	async created() {
		const id = this.$route.params.id;
		if (id && id != this.game.id) {
			await this.$store.dispatch(types.GET, id);
			this.openPanels.push(0);
			this.$store.commit(types.SHOW_IN_TOOLBAR, true);
		} else if (id) {
			this.openPanels.push(0, 1);
			this.$store.commit(types.SHOW_IN_TOOLBAR, true);
		}
		this.$store.commit(types.IS_CREATE_GAME_SCREEN, true);
	},
	watch: {
		routeGameId() {
			if (this.routeGameId) {
				this.openPanels.push(0, 1);
			}
		}
	},
	destroyed() {
		this.$store.commit(types.DISPLAY, 3);
		this.$store.commit(types.DISPLAY_VIEW, "desktop");
		this.$store.commit(types.IS_CREATE_GAME_SCREEN, false);
	},
	methods: {
    async onDelete() {
      const response = await this.$notification.warning(
          this.$t("pages.mygames.popupDelete") + " " + this.game.name + "?", "",
          {
            confirmButtonText: this.$t("generics.accept"),
            cancelButtonText: this.$t("generics.cancel"),
          }
      );
      if (response.isConfirmed) {
        await this.$store.dispatch(types.REMOVE, this.game);
        this.$router.push({ name: "/games" });
      }
    },
		onSave(game) {
			this.$store.commit(types.GET, game);
			this.$store.commit(types.SHOW_IN_TOOLBAR, true);
			if (!this.$route.params.id) {
				this.$router.push({
					name: "game-form",
					params: { id: game.id },
				});
			} else {
				this.openPanels.push(0, 1);
			}
		}
	},
};
</script>

<style scoped>

</style>
